/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: BodyJackpotPanel.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 11:33 am.
 * Last modified: 05.07.22 11:33 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';

/*
 format number as follow:
 1 => 1.00
 34567 => 34 567.00
 1234.56 => 1 234.56
*/

const BodyJackpotPanel = ({ group, jackpotComponent }: ISectionBodyJackpotPanel) => {
    const JackpotComponent = jackpotComponent;
    return (
        <div className={`egt_section_body_panel egt_section_body_panel_${group.toLowerCase()}`}>
            <JackpotComponent group={group} />
        </div>
    );
};

export interface ISectionBodyJackpotPanel {
    group: string;
    jackpotComponent: React.FunctionComponent<{ group: string }>;
}

export default BodyJackpotPanel;
